import { SettingsPermissions } from "@redotech/account-common/permissions";
import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { memo } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { CsatSettingsShell } from "../../../setting/customer-satisfaction/csat-settings-shell";

/** Holds the shared CSAT form open across the sub-page routes. */
const CsatSettingsLayout = memo(function CsatSettingsLayout() {
  return (
    <CsatSettingsShell>
      <Outlet />
    </CsatSettingsShell>
  );
});

/**
 * Sub-pages share one layout route because the CSAT save writes the whole
 * settings object; splitting the form would let one page clobber another.
 */
export const csatRoutes: PermissionedRouteObject[] = [
  {
    handle: {
      breadcrumb: "CSAT",
      permission: SettingsPermissions.SET_SUPPORT_SETTINGS,
    },
    element: <CsatSettingsLayout />,
    children: [
      { index: true, element: <Navigate replace to="general" /> },
      {
        path: "general",
        handle: { breadcrumb: "General" },
        async lazy() {
          const { CsatGeneralPage } =
            await import("../../../setting/customer-satisfaction/csat-pages");
          return { Component: CsatGeneralPage };
        },
      },
      {
        path: "template",
        handle: { breadcrumb: "Templates" },
        async lazy() {
          const { CsatTemplatePage } =
            await import("../../../setting/customer-satisfaction/csat-pages");
          return { Component: CsatTemplatePage };
        },
      },
      {
        path: "ab-tests",
        handle: { breadcrumb: "A/B test" },
        async lazy() {
          const { CsatAbTestsPage } =
            await import("../../../setting/customer-satisfaction/csat-pages");
          return { Component: CsatAbTestsPage };
        },
      },
    ],
  },
];
